import { TmcContextService } from './../../../../../../../common/tmc-context.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Task } from '../../../../../../../client/model/yard-configuration';
import { TranslationService } from '@sdbn/common';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';
import { FilterCondition } from '../../../../filter-administration.model';
import { FilterAdministrationContext } from '../../../../filter-administration.context';

@Component({
    selector: 'app-open-task-editor',
    templateUrl: './open-task-editor.component.html',
    styleUrls: ['./open-task-editor.component.scss'],
    standalone: false
})
export class OpenTaksOfTypeEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  tasks: Task[] = [];

  tmcContextSubscription: Subscription;

  locations: string[] = [];

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  detailsFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService
  ) {

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(
      yard => {
        this.tasks = this.tmcContextService.getYardConfiguration().tasks;
      }
    );

    this.detailsFormGroup.addControl('taskTypeExternalKey', new FormControl('', []));
    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty) {
          this.condition.data.taskTypeExternalKey = this.detailsFormGroup.controls.taskTypeExternalKey.value;
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.detailsFormGroup.reset(this.condition.data);
  }

}
